module.exports = "/_next/static/images/14-1-b9b4731e30b90094505e1e308ecad45d.svg";